import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./listofSubscribers.css";
import Header from "../../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

function ListofSubscribers() {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const [subscribers, setSubscribers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("/api/subscribers", {
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      })
      .then((response) => {
        const dataResponse = response.data.map((certificates, index) => ({
          ...certificates,
          rowNumber: index + 1,
        }));
        setSubscribers(dataResponse);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [accessToken]);

  const handleView = (subscriberCode, subscriberName, id) => {
    const subscriberDetails = {
      subscriberCode,
      subscriberName,
      id      
    };
    navigate("/ViewSubscriberDetails", { state: { subscriberDetails } });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the subscriber?")) {
      axios
        .post(
          "/api/delete-subscriber",
          { id }, {
            headers: {
              'Authorization': 'Bearer ' + accessToken
            }
          }
        )
        .then((response) => {
          // Remove the deleted row from the local data source
          setSubscribers((prevSubscribers) =>
          prevSubscribers.filter((subscriber) => subscriber.id !== id)
          );
          toast.success("Subscriber successfully deleted!", {
            position: toast.POSITION.TOP_CENTER,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.1,
    },
    {
      field: "subscriber_code",
      headerName: "Subscriber Code",
      flex: 0.4,
    },
    {
      field: "subscriber_name",
      headerName: "Subscriber Name",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <>
            <button
              className="deleteSubscriberButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete Subscriber
            </button>
            <button
              className="updateSubscriberButton"
              onClick={() =>
                handleView(
                  params.row.subscriber_code,
                  params.row.subscriber_name,
                  params.row.id,
                )
              }
            >
              Update Subscriber
            </button>
          </>
        );
      },
    },
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Box m="20px">
            <Header
              title="SUBSCRIBERS"
              subtitle="View all subscribers in the system"
            />
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={subscribers}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
      <ToastContainer />
    </div>
  );
}

export default ListofSubscribers;
